import { Component, OnInit, Input, ViewChild} from '@angular/core';
import { MarketingMessagesSlotLayoutComponent } from './marketing-messages-slot-layout/marketing-messages-slot-layout.component';


@Component({
  selector: 'pru-marketing-messages-manager-layouts',
  templateUrl: './marketing-messages-manager-layouts.component.html',
  styleUrls: ['./marketing-messages-manager-layouts.component.scss']
})
export class MarketingMessagesManagerLayoutsComponent implements OnInit {
  
  @ViewChild('marketingMessagesSlotLayoutComponent') marketingMessagesSlotLayoutComponent: MarketingMessagesSlotLayoutComponent;

  constructor() { }

  @Input() marketingContents: any[];
  @Input() contentId:string;
  @Input() retirementLink:string;
  
  ngOnInit() {}

  /*
    This function used to retrieve background color(theme-Default,
    Light Gray, Blue, Navy) based on marketing slot theme.
  */
  getBackgroundColorBasedOnTheme(marketingTheme):any{
    
      if(marketingTheme=='Default'|| marketingTheme==''){
        return "white-background";
      }else if(marketingTheme=='Lightest Gray'){
        return "gray-background"
      } else if(marketingTheme=='Navy'){
        return "navy-background";
      } else if(marketingTheme=='Blue'){
        return "blue-background";
      }
    
  }

}
